import { createSelector } from "reselect";
import { getBreakpointDefinition } from "utils/Breakpoint";

const getViewportHeight = (state) => state.viewport.dimensions.height;
const getViewportWidth = (state) => state.viewport.dimensions.width;

export default createSelector(
  [getViewportHeight, getViewportWidth],
  (viewportHeight, viewportWidth) =>
    getBreakpointDefinition({
      height: viewportHeight,
      width: viewportWidth,
    }),
);
